<template>
	<inertia-head title="Bo Sanchez FREE Ebook - Seven Success Principles" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Freebook QR Code
					</h1>
					
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-12 col-lg-12">
				<h2 v-if="count" class="text-center">
					<span class="me-1 badge bg-info">Total Registered: {{count.registered}}</span>
					<span class="badge bg-success">Total Claimed: {{count.claimed}}</span>
				</h2>
				<div class="row justify-content-center mb-5">
					<div class="col-md-4">
						<table class="table">
							<thead>
								<tr>
									<th>Date</th>
									<th class="text-end">Claimed</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="claim in datesClaimed">
									<td>{{claim.date}}</td>
									<td class="text-end">{{claim.total}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<h2 class="text-center">Type in the QR Code</h2>
				<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="form-group mb-3">
							<label>QR Code</label>
							<input type="text" v-model="form.qrcode" name="qrcode" class="form-control" />
							<span v-if="form.errors.qrcode" class="text-danger">{{form.errors.qrcode}}</span>
						</div>
						<div class="form-group mt-4 text-center">
							<button @click="claimBook" type="button" class="btn btn-success" :disabled="form.processing">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-envelope me-1"></i>
								Claim Now!
							</button>
						</div>
						
					</div>
				</div>
				<div class="block block-rounded mt-5">
					<div class="block-header fw-bold">Check Mobile</div>
					<div class="block-content block-content-full">
						<div class="form-group mb-3">
							<label>Mobile</label>
							<input type="text" v-model="formM.mobile" name="mobile" class="form-control" />
						</div>
						<div class="form-group mt-4 text-center">
							<button @click="deleteMobile" type="button" class="btn btn-danger" :disabled="formM.processing">
								<div
									v-if="formM.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-mobile me-1"></i>
								Delete Mobile
							</button>
						</div>
						
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; <span data-toggle="year-copy"></span>
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: GuestLayout,
		props:{
			flash 			: Object,
			errors			: Object,
			count			: Object,
			datesClaimed	: Object,
		},
		setup(props){

			const form = useForm({
				qrcode 		: ''
			});

			const formM = useForm({
				mobile 		: ''
			});

			const claimBook = ()=>{
				form.get("/freebook/"+form.qrcode);
			}

			const deleteMobile = ()=>{
				formM.get("/freebook/check/mobile",{
					preserveState: true,
					preserveScroll: true
				});
			}

			return {
				form,
				formM,
				claimBook,
				deleteMobile
			}

		}
	}
</script>